// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "app-main" + ".css?" + "cef119a048d90a9b869f" + "";
};